import { FC } from "react";

// styles
import styles from "./searchQueryElementHitCount.module.scss";

export type TSearchQueryElementHitCountProps = {
    text: string,
    hitCountInCurrentQuery?: number,
    isEnabled: boolean,
    id: string | number,
    onEnableChange: (id: string | number, isEnabled: boolean) => void
};

export const SearchQueryElementHitCount: FC<TSearchQueryElementHitCountProps> = ({id, text, hitCountInCurrentQuery, 
        isEnabled, onEnableChange}: TSearchQueryElementHitCountProps) => {

    const onCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onEnableChange(id, event.target.checked);
    };

    return (
        <div className={styles.searchQueryElementHitCount}>
            <label className={styles.checkboxContainer}>
                <input className={styles.checkbox} type="checkbox" checked={isEnabled} onChange={onCheckboxChange}/>
                <span className={styles.checkmark} />
                {text}
            </label>
            {hitCountInCurrentQuery !== undefined ?
                <div className={styles.clusterCount}>{hitCountInCurrentQuery.toString()}</div>
                : null}
        </div>
    );
};